import {
  Router,
  NavigationGuard,
  NavigationHookAfter,
  RouteLocationNormalized,
} from 'vue-router'
import trackPageView from '../middleware/analytics/after/trackPageView'
import enableLiveChat from '../middleware/liveChat/after/enableLiveChat'
import removeCookieConsent from './removeCookieConsent/removeCookieConsent'
import applyPageMeta from '../middleware/pageMeta/before/applyPageMeta'
import applyAuthenticatedRedirects from './pageMeta/before/applyAuthenticatedRedirect'
import applyAuthenticationRequired from './pageMeta/before/applyAuthenticationRequired'
import applyPremiumPlanRequired from './pageMeta/before/applyPremiumPlanRequired'

export const beforeMiddleware: NavigationGuard[] = [
  applyAuthenticationRequired,
  applyAuthenticatedRedirects,
  applyPremiumPlanRequired,
  applyPageMeta,
  removeCookieConsent,
]

export const afterMiddleware: NavigationHookAfter[] = [
  trackPageView as NavigationHookAfter,
  enableLiveChat,
]

export function applyMiddleware(router: Router): void {
  router.beforeEach(applyBeforeMiddleware)
  router.afterEach(applyAfterMiddleware)
}

export const applyBeforeMiddleware = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next
) => {
  let processedCount = 0
  for (let i = 0; i < beforeMiddleware.length; i++) {
    const cont = beforeMiddleware[i](to, from, next)

    if (!cont) {
      break
    }

    processedCount++
  }

  if (processedCount === beforeMiddleware.length) {
    next()
  }
}

export const applyAfterMiddleware = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  afterMiddleware.forEach((m: NavigationHookAfter) => m(to, from))
}
